export default __webpack_public_path__ + "static/media/IMG_5354.5116246e.WEBP";